// UserTypeBreakdown.js
import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { UsersWithOutAppIcon, UserWithAppIcon } from "../../../icons";
import { useSelector } from "react-redux";
import { fetchSignUpDistribution } from "../../../api/nystats";

const UserTypeBreakdown = ({ userTypes, isLoading }) => {
	const { filter } = useSelector((state) => state);

	const [withApp, setWithApp] = useState({
		totalUsers: 0,
		percentOfTotal: 0,
		activeUsers: 0,
		premiumSubscribers: 0,
	});
	const [withoutApp, setWithoutApp] = useState({
		totalUsers: 0,
		percentOfTotal: 0,
		status: "No app installation",
	});

	useEffect(() => {
		const load = async () => {
			try {
				// const { userTypes } = await fetchSignUpDistribution(filter);
				if (userTypes) {
					setWithApp(userTypes.withApp);
					setWithoutApp(userTypes.withoutApp);
				}
			} catch (e) {
				console.error("Error loading user type breakdown", e);
			}
		};
		load();
	}, [userTypes]);

	return (
		<Box
			sx={{
				border: "1px solid #e6e6e6",
				borderRadius: "12px",
				p: 2,
				background: "#fff",
			}}
		>
			<Typography
				sx={{
					fontSize: "18px",
					fontWeight: 500,
					color: "#101828",
					mb: 3,
					borderLeft: "3px solid #FBBF24",
					pl: 1,
				}}
			>
				User Type Breakdown
			</Typography>

			{
				isLoading ? <Box sx={{ textAlign: 'center', py: 4 }}>
					<Typography variant="body1" color="text.secondary">
						Loading...
					</Typography>
				</Box> : <>
					<Box
						sx={{
							display: "flex",
							justifyContent: "space-between",
							alignItems: "stretch",
							gap: 2,
						}}
					>
						{/* Users With App */}
						<Box sx={{ width: "100%" }}>
							<Typography
								sx={{
									display: "flex",
									alignItems: "center",
									gap: 1,
									mb: 2,
									fontSize: "16px",
								}}
							>
								<UserWithAppIcon /> Users With App
							</Typography>
							<Box sx={{ background: "#F5F3F0", p: 2, borderRadius: 2, width: "100%" }}>
								<Box
									sx={{
										borderBottom: "1px solid #E5E1DC",
										display: "grid",
										gridTemplateColumns: "repeat(2, 1fr)",
										pb: 2,
										mb: 2,
									}}
								>
									<Typography sx={{ fontSize: "24px", color: "#0A0A0A" }}>
										<Typography
											sx={{
												display: "block",
												fontSize: "12px",
												color: "#6B6B6B",
											}}
										>
											Total Users
										</Typography>
										{withApp.totalUsers.toLocaleString()}
									</Typography>
									<Typography sx={{ fontSize: "24px", color: "#0A0A0A" }}>
										<Typography
											sx={{
												display: "block",
												fontSize: "12px",
												color: "#6B6B6B",
											}}
										>
											Percent of total
										</Typography>
										{withApp.percentOfTotal}%
									</Typography>
								</Box>
								<Box sx={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)" }}>
									<Typography sx={{ fontSize: "20px", color: "#0A0A0A" }}>
										<Typography
											sx={{
												display: "block",
												fontSize: "12px",
												color: "#6B6B6B",
											}}
										>
											Active Users
										</Typography>
										{withApp?.activeUsers?.toLocaleString()}
									</Typography>
									<Typography sx={{ fontSize: "20px", color: "#0A0A0A" }}>
										<Typography
											sx={{
												display: "block",
												fontSize: "12px",
												color: "#6B6B6B",
											}}
										>
											Premium Subscribers
										</Typography>
										{withApp.premiumSubscribers?.toLocaleString()}
									</Typography>
								</Box>
							</Box>
						</Box>

						{/* Users Without App */}
						<Box sx={{ width: "100%" }}>
							<Typography
								sx={{
									display: "flex",
									alignItems: "center",
									gap: 1,
									mb: 2,
									fontSize: "16px",
								}}
							>
								<UsersWithOutAppIcon /> Users Without App
							</Typography>
							<Box sx={{ background: "#F5F3F0", p: 2, borderRadius: 2, width: "100%" }}>
								<Box
									sx={{
										borderBottom: "1px solid #E5E1DC",
										display: "grid",
										gridTemplateColumns: "repeat(2, 1fr)",
										pb: 2,
										mb: 2,
									}}
								>
									<Typography sx={{ fontSize: "24px", color: "#0A0A0A" }}>
										<Typography
											sx={{
												display: "block",
												fontSize: "12px",
												color: "#6B6B6B",
											}}
										>
											Total Users
										</Typography>
										{withoutApp.totalUsers.toLocaleString()}
									</Typography>
									<Typography sx={{ fontSize: "24px", color: "#0A0A0A" }}>
										<Typography
											sx={{
												display: "block",
												fontSize: "12px",
												color: "#6B6B6B",
											}}
										>
											Percent of total
										</Typography>
										{withoutApp.percentOfTotal}%
									</Typography>
								</Box>
								<Box>
									<Typography sx={{ fontSize: "16px", color: "#0A0A0A" }}>
										<Typography
											sx={{
												display: "block",
												fontSize: "12px",
												color: "#6B6B6B",
											}}
										>
											Status
										</Typography>
										{withoutApp.status}
									</Typography>
								</Box>

								<Typography sx={{ fontSize: "16px", color: "#0A0A0A" }}>
									<Typography
										sx={{
											display: "block",
											fontSize: "12px",
											color: "#6B6B6B",
										}}
									>
										Premium Subscribers
									</Typography>
									{withoutApp?.premiumSubscribers?.toLocaleString()}
								</Typography>

							</Box>
						</Box>
					</Box>
				</>}

		</Box>
	);
};

export default UserTypeBreakdown;
